module.exports = __webpack_public_path__ + "static/media/logo-2.9adc8daa.jpg";